import { HStack } from '../../Core/HStack';
import { EllipsisBoxWithTooltip } from '../../Form/BaseSelect/EllipsisBoxWithTooltip';
import { Text } from '../../Text';

interface EntityAdminDrawerHeaderProps {
  drawerTitle: string;
  /** Selected amount of rows you're editing. If this is 0, the drawer header will say its in Create mode, else Edit mode */
  selectedCount: number;
  /** Whether we're creating a child entity. If true, always show "Creating" regardless of selectedCount */
  addingChildEntity?: boolean;
}

export function EntityAdminDrawerHeader({
  drawerTitle,
  selectedCount,
  addingChildEntity = false,
}: EntityAdminDrawerHeaderProps) {
  const isEditing = !addingChildEntity && selectedCount > 0;
  const titleChipText = !isEditing ? 'Creating' : selectedCount === 1 ? 'Editing' : `Editing ${selectedCount} Rows`;

  return (
    <HStack
      gap="spacing8"
      minWidth={0}
      maxWidth="100%"
      flex="1"
      overflow="hidden"
      justifyContent="flex-start"
      alignItems="center"
    >
      <EllipsisBoxWithTooltip
        data-testid="title-text"
        outerBoxProps={{ minWidth: 0, flex: '0 1 auto', maxWidth: '100%' }}
        color="colorTextImportant"
      >
        {drawerTitle}
      </EllipsisBoxWithTooltip>
      <Text
        flex="0 0 auto"
        p="spacing4"
        px="spacing8"
        background={isEditing ? 'backgroundPrimaryButton' : 'backgroundPositiveButton'}
        color={isEditing ? 'colorTextPrimaryButton' : 'colorTextPositiveButton'}
        borderRadius="borderRadiusDefault"
        data-testid="title-chip"
        fontSize="fontSizeSmall"
        whiteSpace="nowrap"
      >
        {titleChipText}
      </Text>
    </HStack>
  );
}
